import gql from 'graphql-tag'

// USED IN: SCHEDULE, PATIENT_NOTES, ACTION_STREAM
export const GetAllNoteTypes = gql`
  query GetAllNoteTypes($userId: ID!) {
    noteTypes(input: { userId: $userId }) {
      count
      results {
        id
        userId
        name
        contentType
      }
    }
  }
`

// USED IN: NOTE_TYPE_EDITOR
export const CreateNoteType = gql`
  mutation CreateNoteType($organizationId: ID!, $noteType: NoteTypeInput!) {
    createNoteType(input: { organizationId: $organizationId, noteType: $noteType }) {
      noteType {
        id
        userId
        name
        keywords
        sections {
          sectionId: id
          name
          navigationKeywords
          content,
          pbcSectionFlag
        }
        destinations,
        specialties,
        emrNoteType {
          id
          code
          name
          codeSystem
        }
      }
    }
  }
`

// USED IN: NOTE_TYPE_EDITOR
export const GetNoteTypeById = gql`
  query GetNoteTypeById($organizationId: ID!, $id: ID!) {
    noteTypes(input: { organizationId: $organizationId, ids: [$id] }) {
      count
      results {
        id
        userId
        name
        keywords
        sections {
          sectionId: id
          name
          navigationKeywords
          content
          pbcSectionFlag
        }
        destinations,
        specialties,
        emrNoteType {
          id
          code,
          name,
          codeSystem
        }
        contentType
      }
    }
  }
`

// USED IN: NOTE_TYPE_EDITOR
export const UpdateNoteType = gql`
  mutation UpdateNoteType($organizationId: ID!, $noteType: NoteTypeInput!) {
    updateNoteType(input: { organizationId: $organizationId, noteType: $noteType }) {
      noteType {
        id
        userId
        name
        keywords
        sections {
          sectionId: id
          name
          navigationKeywords
          content,
          pbcSectionFlag
        }
        destinations,
        specialties,
        emrNoteType {
          id
          code,
          name,
          codeSystem
        }
      }
    }
  }
`

export const GetEmrNotetypes = gql`
  query GetEmrNotetypes($organizationId: ID!, $specialties: [SpecialtyType]) {
    emrNoteTypes(input: {
      organizationId: $organizationId,
      specialties: $specialties
    }) {
    emrNoteTypes {
      id
      code,
      name,
      codeSystem
    }
  }
}`

// USED IN: SETTINGS
export const DeleteNoteTypes = gql`
  mutation DeleteNoteTypes($organizationId: ID!, $ids: [ID!]!) {
    deleteNoteTypes(input: { organizationId: $organizationId, ids: $ids }) {
      ids
    }
  }
`
